import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, IconButton } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { formatMoney } from 'src/utils/common';
import { useStyles } from './styles';

function CardPlanosAssinatura(props) {
  const classes = useStyles();

  const valueString = formatMoney(parseFloat(props.plan.valor) / 100) + '/mês';

  const handleClick = () => {
    props.onClick?.(props.plan);
  };

  return (
    <div>
      <Card className={classes.card}>
        <CardHeader
          title={`${props.plan.nome} - ${valueString}`}
          subheader={props.planDescription}
          action={
            <IconButton
              className={classes.next}
              aria-label="settings"
              onClick={handleClick}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </IconButton>
          }
        />
      </Card>
    </div>
  );
}

CardPlanosAssinatura.propTypes = {
  plan: PropTypes.shape({
    nome: PropTypes.string,
    valor: PropTypes.number,
  }).isRequired,
  planDescription: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CardPlanosAssinatura;
